module.exports = __webpack_public_path__ + "img/icon-home-video.a9036660.png";